<script>
export default {
	props: {
		item: Object,
	},
	methods: {
		bgImageStyle(item) {
			if (!item.img) return null
			let { src } = this.$media(item.img)
			const styles = {
				backgroundImage: `url('${src}')`,
				backgroundPosition: 'right bottom',
				backgroundRepeat: 'no-repeat',
				backgroundSize: 'contain',
			}
			return styles
		},
		doToggle(hover, toggle) {
			if (this.$b.t && hover) toggle()
		},
	},
}
</script>

<template>
	<div :class="[$bem('mega-menu'), 'px-0', 'd-flex']" min-width="200px">
		<Hover
			v-slot="{ hover, toggle }"
			unhover-on-route-loading
			:open-delay="$b.d ? 250 : 0"
			:close-delay="$b.d ? 250 : 0"
			:value="globalHover"
			@updateModel="updateHover($event, index)"
		>
			<div>
				<SafeLink class="d-inline-block pt-3">
					<v-btn
						:color="$vars.basetext"
						class="h100"
						:class="[
							$bem('__underline'),
							{ [$bem('__underline--permanent')]: hover || forceHover == index },
						]"
						text
						depressed
						small
						@click="doToggle(hover, toggle)"
					>
						<v-list-item-title
							v-html="
								item.selectType == 'brand'
									? item.brand.name
									: item.selectType == 'url'
									? item.name
									: item.category.name
							"
						>
						</v-list-item-title>
					</v-btn>
				</SafeLink>
				<div
					class="px-6 py-1 pb-6 rounded"
					:class="[$bem('__submenu'), submenuClass]"
					:style="[
						bgImageStyle(item),
						{ 'max-height': `${cMaxHeight}px!important` },
						widthStyle,
						submenuStyle,
					]"
					v-show="!close && (hover || forceHover === index)"
				>
					<!-- Title -->
					<div :class="$bem('__title-wrapper')">
						<CategoriesMegaMenu-CategoryTitle
							v-if="!item.disableTitle"
							:item="item"
							@click.native="toggle"
						/>
					</div>

					<CategoriesMenu :items="item.ordered" :link="item.link" />
				</div>
			</div>
		</Hover>
	</div>
</template>

<style lang="scss" scoped>
.mega-menu {
	min-height: 52px;

	&__underline {
		&::after {
			content: ' ';
			position: absolute;
			left: 0;
			right: 0;
			border-bottom: 1px solid var(--basetext);
			bottom: 4px;
			margin-right: 10px;
			margin-left: 10px;
			transform: scaleX(0);
			transform-origin: bottom center;
			transition: transform 0.25s ease-out;
		}
		&:hover::after {
			transform: scaleX(1);
			transform-origin: bottom center;
		}
		&--permanent::after {
			transform: scaleX(1);
			transform-origin: bottom center;
		}
	}

	&__submenu {
		position: absolute;
		min-height: 350px;
		overflow: auto;
		background-color: var(--secondary);
		width: 100%;
		// margin-left: -50%;
		top: 52px;
		z-index: 3;

		&::-webkit-scrollbar {
			width: 3px;
		}

		&::-webkit-scrollbar-track {
			box-shadow: inset 0 0 6px rgba(145, 144, 144, 0.3);
		}

		&::-webkit-scrollbar-thumb {
			background-color: var(--base);
			outline: 1px solid rgb(143, 143, 144);
		}
	}

	&__title-wrapper {
		min-height: 53.39px;
	}
}
</style>

